import $067dbd0c037ad155$exports from "./ar-AE.mjs";
import $6ee4da2747de1e02$exports from "./bg-BG.mjs";
import $b58a7d965b7aa1b3$exports from "./cs-CZ.mjs";
import $ecaca51f024191b0$exports from "./da-DK.mjs";
import $6e434aa373f128b4$exports from "./de-DE.mjs";
import $ddbe45fb199df913$exports from "./el-GR.mjs";
import $2083b83b84266bb4$exports from "./en-US.mjs";
import $a41434a97f5222d7$exports from "./es-ES.mjs";
import $0a1b42c97638052f$exports from "./et-EE.mjs";
import $177331a39d162ddc$exports from "./fi-FI.mjs";
import $273b1d5ecf07fe52$exports from "./fr-FR.mjs";
import $459441d19cfa90a8$exports from "./he-IL.mjs";
import $c30474fbd65b2878$exports from "./hr-HR.mjs";
import $fd19cc1d41a750e5$exports from "./hu-HU.mjs";
import $158d0aece262406d$exports from "./it-IT.mjs";
import $bc830316669a23f8$exports from "./ja-JP.mjs";
import $7fa23663d4de476d$exports from "./ko-KR.mjs";
import $827e42814bc8f58e$exports from "./lt-LT.mjs";
import $6ca653959481d2db$exports from "./lv-LV.mjs";
import $9efb74877777657a$exports from "./nb-NO.mjs";
import $d085d780952864a7$exports from "./nl-NL.mjs";
import $c207a8811c9791e9$exports from "./pl-PL.mjs";
import $eda3511d3b2e0e51$exports from "./pt-BR.mjs";
import $a9c1da319e5254cb$exports from "./pt-PT.mjs";
import $bc5c688ddc9e69fb$exports from "./ro-RO.mjs";
import $84ec40785c299370$exports from "./ru-RU.mjs";
import $510ebbcbf8f3c784$exports from "./sk-SK.mjs";
import $49f018934e6f92c2$exports from "./sl-SI.mjs";
import $7513a1b075b503d5$exports from "./sr-SP.mjs";
import $02c92e5e0c81f9a9$exports from "./sv-SE.mjs";
import $8165adf786eb9d46$exports from "./tr-TR.mjs";
import $228238165c1367ae$exports from "./uk-UA.mjs";
import $cc82b5cf91ddc409$exports from "./zh-CN.mjs";
import $c1545fe26f1d3e20$exports from "./zh-TW.mjs";
import "./main.css";
import {Item as $ee97ea796309b076$re_export$Item, Section as $ee97ea796309b076$re_export$Section} from "@react-stately/collections";
import $j8tbs$react, {useMemo as $j8tbs$useMemo, useContext as $j8tbs$useContext, useRef as $j8tbs$useRef, Fragment as $j8tbs$Fragment} from "react";
import {useDOMRef as $j8tbs$useDOMRef, useStyleProps as $j8tbs$useStyleProps, classNames as $j8tbs$classNames, ClearSlots as $j8tbs$ClearSlots, SlotProvider as $j8tbs$SlotProvider} from "@react-spectrum/utils";
import {useListState as $j8tbs$useListState} from "@react-stately/list";
import {useListBox as $j8tbs$useListBox, useOption as $j8tbs$useOption, useListBoxSection as $j8tbs$useListBoxSection} from "@react-aria/listbox";
import {FocusScope as $j8tbs$FocusScope, FocusRing as $j8tbs$FocusRing} from "@react-aria/focus";
import {ListLayout as $j8tbs$ListLayout} from "@react-stately/layout";
import {useLayoutEffect as $j8tbs$useLayoutEffect, mergeProps as $j8tbs$mergeProps} from "@react-aria/utils";
import {ProgressCircle as $j8tbs$ProgressCircle} from "@react-spectrum/progress";
import {useCollator as $j8tbs$useCollator, useLocalizedStringFormatter as $j8tbs$useLocalizedStringFormatter, useLocale as $j8tbs$useLocale} from "@react-aria/i18n";
import {useProvider as $j8tbs$useProvider} from "@react-spectrum/provider";
import {VirtualizerItem as $j8tbs$VirtualizerItem, Virtualizer as $j8tbs$Virtualizer, useVirtualizerItem as $j8tbs$useVirtualizerItem, layoutInfoToStyle as $j8tbs$layoutInfoToStyle} from "@react-aria/virtualizer";
import $j8tbs$spectrumiconsuiCheckmarkMedium from "@spectrum-icons/ui/CheckmarkMedium";
import {Grid as $j8tbs$Grid} from "@react-spectrum/layout";
import {useHover as $j8tbs$useHover, isFocusVisible as $j8tbs$isFocusVisible} from "@react-aria/interactions";
import {Text as $j8tbs$Text} from "@react-spectrum/text";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


var $0815878b47e2c7ae$exports = {};


































$0815878b47e2c7ae$exports = {
    "ar-AE": $067dbd0c037ad155$exports,
    "bg-BG": $6ee4da2747de1e02$exports,
    "cs-CZ": $b58a7d965b7aa1b3$exports,
    "da-DK": $ecaca51f024191b0$exports,
    "de-DE": $6e434aa373f128b4$exports,
    "el-GR": $ddbe45fb199df913$exports,
    "en-US": $2083b83b84266bb4$exports,
    "es-ES": $a41434a97f5222d7$exports,
    "et-EE": $0a1b42c97638052f$exports,
    "fi-FI": $177331a39d162ddc$exports,
    "fr-FR": $273b1d5ecf07fe52$exports,
    "he-IL": $459441d19cfa90a8$exports,
    "hr-HR": $c30474fbd65b2878$exports,
    "hu-HU": $fd19cc1d41a750e5$exports,
    "it-IT": $158d0aece262406d$exports,
    "ja-JP": $bc830316669a23f8$exports,
    "ko-KR": $7fa23663d4de476d$exports,
    "lt-LT": $827e42814bc8f58e$exports,
    "lv-LV": $6ca653959481d2db$exports,
    "nb-NO": $9efb74877777657a$exports,
    "nl-NL": $d085d780952864a7$exports,
    "pl-PL": $c207a8811c9791e9$exports,
    "pt-BR": $eda3511d3b2e0e51$exports,
    "pt-PT": $a9c1da319e5254cb$exports,
    "ro-RO": $bc5c688ddc9e69fb$exports,
    "ru-RU": $84ec40785c299370$exports,
    "sk-SK": $510ebbcbf8f3c784$exports,
    "sl-SI": $49f018934e6f92c2$exports,
    "sr-SP": $7513a1b075b503d5$exports,
    "sv-SE": $02c92e5e0c81f9a9$exports,
    "tr-TR": $8165adf786eb9d46$exports,
    "uk-UA": $228238165c1367ae$exports,
    "zh-CN": $cc82b5cf91ddc409$exports,
    "zh-TW": $c1545fe26f1d3e20$exports
};


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $0c6f792811e33483$export$7ff8f37d2d81a48d = (0, $j8tbs$react).createContext(null);


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 







var $286d1cb34bb7dc84$exports = {};

$parcel$export($286d1cb34bb7dc84$exports, "checkmark", () => $286d1cb34bb7dc84$export$292abbf31ed842a, (v) => $286d1cb34bb7dc84$export$292abbf31ed842a = v);
$parcel$export($286d1cb34bb7dc84$exports, "chevron", () => $286d1cb34bb7dc84$export$980c1089c0604ea3, (v) => $286d1cb34bb7dc84$export$980c1089c0604ea3 = v);
$parcel$export($286d1cb34bb7dc84$exports, "description", () => $286d1cb34bb7dc84$export$6d59db4903f20f7d, (v) => $286d1cb34bb7dc84$export$6d59db4903f20f7d = v);
$parcel$export($286d1cb34bb7dc84$exports, "end", () => $286d1cb34bb7dc84$export$bd5df0f255a350f8, (v) => $286d1cb34bb7dc84$export$bd5df0f255a350f8 = v);
$parcel$export($286d1cb34bb7dc84$exports, "focus-ring", () => $286d1cb34bb7dc84$export$f39a09f249340e2a, (v) => $286d1cb34bb7dc84$export$f39a09f249340e2a = v);
$parcel$export($286d1cb34bb7dc84$exports, "i18nFontFamily", () => $286d1cb34bb7dc84$export$8c4ee2c50c22c514, (v) => $286d1cb34bb7dc84$export$8c4ee2c50c22c514 = v);
$parcel$export($286d1cb34bb7dc84$exports, "icon", () => $286d1cb34bb7dc84$export$1ca1ec8b29a4ce27, (v) => $286d1cb34bb7dc84$export$1ca1ec8b29a4ce27 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-active", () => $286d1cb34bb7dc84$export$20fd0f7cd4e6112f, (v) => $286d1cb34bb7dc84$export$20fd0f7cd4e6112f = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-disabled", () => $286d1cb34bb7dc84$export$d35bc1e505d1ebbf, (v) => $286d1cb34bb7dc84$export$d35bc1e505d1ebbf = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-expanded", () => $286d1cb34bb7dc84$export$911ebb89bba4b634, (v) => $286d1cb34bb7dc84$export$911ebb89bba4b634 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-focused", () => $286d1cb34bb7dc84$export$e7dc768d35940237, (v) => $286d1cb34bb7dc84$export$e7dc768d35940237 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-highlighted", () => $286d1cb34bb7dc84$export$451c613d0772eb99, (v) => $286d1cb34bb7dc84$export$451c613d0772eb99 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-hovered", () => $286d1cb34bb7dc84$export$b8813cd5d7824ce7, (v) => $286d1cb34bb7dc84$export$b8813cd5d7824ce7 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-open", () => $286d1cb34bb7dc84$export$a9781837241c946d, (v) => $286d1cb34bb7dc84$export$a9781837241c946d = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-selectable", () => $286d1cb34bb7dc84$export$fbd22ba224473193, (v) => $286d1cb34bb7dc84$export$fbd22ba224473193 = v);
$parcel$export($286d1cb34bb7dc84$exports, "is-selected", () => $286d1cb34bb7dc84$export$1e0fb04f31d3c22a, (v) => $286d1cb34bb7dc84$export$1e0fb04f31d3c22a = v);
$parcel$export($286d1cb34bb7dc84$exports, "keyboard", () => $286d1cb34bb7dc84$export$cfdd767f5a513509, (v) => $286d1cb34bb7dc84$export$cfdd767f5a513509 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-FocusRing-ring", () => $286d1cb34bb7dc84$export$4109102f950813a6, (v) => $286d1cb34bb7dc84$export$4109102f950813a6 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-FocusRing", () => $286d1cb34bb7dc84$export$24c7f46a6e3605dd, (v) => $286d1cb34bb7dc84$export$24c7f46a6e3605dd = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-FocusRing--quiet", () => $286d1cb34bb7dc84$export$2927016961429360, (v) => $286d1cb34bb7dc84$export$2927016961429360 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Icon", () => $286d1cb34bb7dc84$export$d374b04f30360026, (v) => $286d1cb34bb7dc84$export$d374b04f30360026 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu", () => $286d1cb34bb7dc84$export$fae6af6decd50ac5, (v) => $286d1cb34bb7dc84$export$fae6af6decd50ac5 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-avatar", () => $286d1cb34bb7dc84$export$944daf9b7d423a02, (v) => $286d1cb34bb7dc84$export$944daf9b7d423a02 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-checkmark", () => $286d1cb34bb7dc84$export$8e15a726e4f7e62d, (v) => $286d1cb34bb7dc84$export$8e15a726e4f7e62d = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-chevron", () => $286d1cb34bb7dc84$export$ca45e0db366b8e6c, (v) => $286d1cb34bb7dc84$export$ca45e0db366b8e6c = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-description", () => $286d1cb34bb7dc84$export$36f1275051e39ead, (v) => $286d1cb34bb7dc84$export$36f1275051e39ead = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-divider", () => $286d1cb34bb7dc84$export$e892026f534efed8, (v) => $286d1cb34bb7dc84$export$e892026f534efed8 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-end", () => $286d1cb34bb7dc84$export$926a1bb74ed65667, (v) => $286d1cb34bb7dc84$export$926a1bb74ed65667 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-icon", () => $286d1cb34bb7dc84$export$cbbae63ef9e44c7a, (v) => $286d1cb34bb7dc84$export$cbbae63ef9e44c7a = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-item", () => $286d1cb34bb7dc84$export$45faad328e6c532b, (v) => $286d1cb34bb7dc84$export$45faad328e6c532b = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemGrid", () => $286d1cb34bb7dc84$export$ee5f52784f57f9c8, (v) => $286d1cb34bb7dc84$export$ee5f52784f57f9c8 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemIcon", () => $286d1cb34bb7dc84$export$f431001e1bb54633, (v) => $286d1cb34bb7dc84$export$f431001e1bb54633 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemLabel", () => $286d1cb34bb7dc84$export$1aa6419c5c650567, (v) => $286d1cb34bb7dc84$export$1aa6419c5c650567 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-itemLabel--wrapping", () => $286d1cb34bb7dc84$export$465092164a8e1d98, (v) => $286d1cb34bb7dc84$export$465092164a8e1d98 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-keyboard", () => $286d1cb34bb7dc84$export$4f9817a7dff6ba0f, (v) => $286d1cb34bb7dc84$export$4f9817a7dff6ba0f = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-popover", () => $286d1cb34bb7dc84$export$d959f30786125b, (v) => $286d1cb34bb7dc84$export$d959f30786125b = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-section--isFirst", () => $286d1cb34bb7dc84$export$dae331c15950f1e, (v) => $286d1cb34bb7dc84$export$dae331c15950f1e = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-section--isLast", () => $286d1cb34bb7dc84$export$9778864c5b622fbc, (v) => $286d1cb34bb7dc84$export$9778864c5b622fbc = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-section--noHeading", () => $286d1cb34bb7dc84$export$8b61ec49b96ad17e, (v) => $286d1cb34bb7dc84$export$8b61ec49b96ad17e = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-sectionHeading", () => $286d1cb34bb7dc84$export$c20ea4b35020fbdd, (v) => $286d1cb34bb7dc84$export$c20ea4b35020fbdd = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-subdialog", () => $286d1cb34bb7dc84$export$d7e47bfca92b5744, (v) => $286d1cb34bb7dc84$export$d7e47bfca92b5744 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-wrapper", () => $286d1cb34bb7dc84$export$76d36e55740ad742, (v) => $286d1cb34bb7dc84$export$76d36e55740ad742 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Menu-wrapper--isMobile", () => $286d1cb34bb7dc84$export$c873119be41fdb72, (v) => $286d1cb34bb7dc84$export$c873119be41fdb72 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Submenu-heading", () => $286d1cb34bb7dc84$export$c830d2588e34dae1, (v) => $286d1cb34bb7dc84$export$c830d2588e34dae1 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Submenu-headingWrapper", () => $286d1cb34bb7dc84$export$d3fc690f61339a08, (v) => $286d1cb34bb7dc84$export$d3fc690f61339a08 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Submenu-popover", () => $286d1cb34bb7dc84$export$fe967dac6207a986, (v) => $286d1cb34bb7dc84$export$fe967dac6207a986 = v);
$parcel$export($286d1cb34bb7dc84$exports, "spectrum-Submenu-wrapper", () => $286d1cb34bb7dc84$export$158cbd6607d36c4e, (v) => $286d1cb34bb7dc84$export$158cbd6607d36c4e = v);
$parcel$export($286d1cb34bb7dc84$exports, "text", () => $286d1cb34bb7dc84$export$6f093cfa640b7166, (v) => $286d1cb34bb7dc84$export$6f093cfa640b7166 = v);
var $286d1cb34bb7dc84$export$292abbf31ed842a;
var $286d1cb34bb7dc84$export$980c1089c0604ea3;
var $286d1cb34bb7dc84$export$6d59db4903f20f7d;
var $286d1cb34bb7dc84$export$bd5df0f255a350f8;
var $286d1cb34bb7dc84$export$f39a09f249340e2a;
var $286d1cb34bb7dc84$export$8c4ee2c50c22c514;
var $286d1cb34bb7dc84$export$1ca1ec8b29a4ce27;
var $286d1cb34bb7dc84$export$20fd0f7cd4e6112f;
var $286d1cb34bb7dc84$export$d35bc1e505d1ebbf;
var $286d1cb34bb7dc84$export$911ebb89bba4b634;
var $286d1cb34bb7dc84$export$e7dc768d35940237;
var $286d1cb34bb7dc84$export$451c613d0772eb99;
var $286d1cb34bb7dc84$export$b8813cd5d7824ce7;
var $286d1cb34bb7dc84$export$a9781837241c946d;
var $286d1cb34bb7dc84$export$fbd22ba224473193;
var $286d1cb34bb7dc84$export$1e0fb04f31d3c22a;
var $286d1cb34bb7dc84$export$cfdd767f5a513509;
var $286d1cb34bb7dc84$export$4109102f950813a6;
var $286d1cb34bb7dc84$export$24c7f46a6e3605dd;
var $286d1cb34bb7dc84$export$2927016961429360;
var $286d1cb34bb7dc84$export$d374b04f30360026;
var $286d1cb34bb7dc84$export$fae6af6decd50ac5;
var $286d1cb34bb7dc84$export$944daf9b7d423a02;
var $286d1cb34bb7dc84$export$8e15a726e4f7e62d;
var $286d1cb34bb7dc84$export$ca45e0db366b8e6c;
var $286d1cb34bb7dc84$export$36f1275051e39ead;
var $286d1cb34bb7dc84$export$e892026f534efed8;
var $286d1cb34bb7dc84$export$926a1bb74ed65667;
var $286d1cb34bb7dc84$export$cbbae63ef9e44c7a;
var $286d1cb34bb7dc84$export$45faad328e6c532b;
var $286d1cb34bb7dc84$export$ee5f52784f57f9c8;
var $286d1cb34bb7dc84$export$f431001e1bb54633;
var $286d1cb34bb7dc84$export$1aa6419c5c650567;
var $286d1cb34bb7dc84$export$465092164a8e1d98;
var $286d1cb34bb7dc84$export$4f9817a7dff6ba0f;
var $286d1cb34bb7dc84$export$d959f30786125b;
var $286d1cb34bb7dc84$export$dae331c15950f1e;
var $286d1cb34bb7dc84$export$9778864c5b622fbc;
var $286d1cb34bb7dc84$export$8b61ec49b96ad17e;
var $286d1cb34bb7dc84$export$c20ea4b35020fbdd;
var $286d1cb34bb7dc84$export$d7e47bfca92b5744;
var $286d1cb34bb7dc84$export$76d36e55740ad742;
var $286d1cb34bb7dc84$export$c873119be41fdb72;
var $286d1cb34bb7dc84$export$c830d2588e34dae1;
var $286d1cb34bb7dc84$export$d3fc690f61339a08;
var $286d1cb34bb7dc84$export$fe967dac6207a986;
var $286d1cb34bb7dc84$export$158cbd6607d36c4e;
var $286d1cb34bb7dc84$export$6f093cfa640b7166;
$286d1cb34bb7dc84$export$292abbf31ed842a = `Q7FggG_checkmark`;
$286d1cb34bb7dc84$export$980c1089c0604ea3 = `Q7FggG_chevron`;
$286d1cb34bb7dc84$export$6d59db4903f20f7d = `Q7FggG_description`;
$286d1cb34bb7dc84$export$bd5df0f255a350f8 = `Q7FggG_end`;
$286d1cb34bb7dc84$export$f39a09f249340e2a = `Q7FggG_focus-ring`;
$286d1cb34bb7dc84$export$8c4ee2c50c22c514 = `Q7FggG_i18nFontFamily`;
$286d1cb34bb7dc84$export$1ca1ec8b29a4ce27 = `Q7FggG_icon`;
$286d1cb34bb7dc84$export$20fd0f7cd4e6112f = `Q7FggG_is-active`;
$286d1cb34bb7dc84$export$d35bc1e505d1ebbf = `Q7FggG_is-disabled`;
$286d1cb34bb7dc84$export$911ebb89bba4b634 = `Q7FggG_is-expanded`;
$286d1cb34bb7dc84$export$e7dc768d35940237 = `Q7FggG_is-focused`;
$286d1cb34bb7dc84$export$451c613d0772eb99 = `Q7FggG_is-highlighted`;
$286d1cb34bb7dc84$export$b8813cd5d7824ce7 = `Q7FggG_is-hovered`;
$286d1cb34bb7dc84$export$a9781837241c946d = `Q7FggG_is-open`;
$286d1cb34bb7dc84$export$fbd22ba224473193 = `Q7FggG_is-selectable`;
$286d1cb34bb7dc84$export$1e0fb04f31d3c22a = `Q7FggG_is-selected`;
$286d1cb34bb7dc84$export$cfdd767f5a513509 = `Q7FggG_keyboard`;
$286d1cb34bb7dc84$export$4109102f950813a6 = `Q7FggG_spectrum-FocusRing-ring`;
$286d1cb34bb7dc84$export$24c7f46a6e3605dd = `Q7FggG_spectrum-FocusRing ${$286d1cb34bb7dc84$export$4109102f950813a6}`;
$286d1cb34bb7dc84$export$2927016961429360 = `Q7FggG_spectrum-FocusRing--quiet`;
$286d1cb34bb7dc84$export$d374b04f30360026 = `Q7FggG_spectrum-Icon`;
$286d1cb34bb7dc84$export$fae6af6decd50ac5 = `Q7FggG_spectrum-Menu`;
$286d1cb34bb7dc84$export$944daf9b7d423a02 = `Q7FggG_spectrum-Menu-avatar`;
$286d1cb34bb7dc84$export$8e15a726e4f7e62d = `Q7FggG_spectrum-Menu-checkmark`;
$286d1cb34bb7dc84$export$ca45e0db366b8e6c = `Q7FggG_spectrum-Menu-chevron`;
$286d1cb34bb7dc84$export$36f1275051e39ead = `Q7FggG_spectrum-Menu-description`;
$286d1cb34bb7dc84$export$e892026f534efed8 = `Q7FggG_spectrum-Menu-divider`;
$286d1cb34bb7dc84$export$926a1bb74ed65667 = `Q7FggG_spectrum-Menu-end`;
$286d1cb34bb7dc84$export$cbbae63ef9e44c7a = `Q7FggG_spectrum-Menu-icon`;
$286d1cb34bb7dc84$export$45faad328e6c532b = `Q7FggG_spectrum-Menu-item`;
$286d1cb34bb7dc84$export$ee5f52784f57f9c8 = `Q7FggG_spectrum-Menu-itemGrid`;
$286d1cb34bb7dc84$export$f431001e1bb54633 = `Q7FggG_spectrum-Menu-itemIcon`;
$286d1cb34bb7dc84$export$1aa6419c5c650567 = `Q7FggG_spectrum-Menu-itemLabel`;
$286d1cb34bb7dc84$export$465092164a8e1d98 = `Q7FggG_spectrum-Menu-itemLabel--wrapping`;
$286d1cb34bb7dc84$export$4f9817a7dff6ba0f = `Q7FggG_spectrum-Menu-keyboard`;
$286d1cb34bb7dc84$export$d959f30786125b = `Q7FggG_spectrum-Menu-popover`;
$286d1cb34bb7dc84$export$dae331c15950f1e = `Q7FggG_spectrum-Menu-section--isFirst`;
$286d1cb34bb7dc84$export$9778864c5b622fbc = `Q7FggG_spectrum-Menu-section--isLast`;
$286d1cb34bb7dc84$export$8b61ec49b96ad17e = `Q7FggG_spectrum-Menu-section--noHeading`;
$286d1cb34bb7dc84$export$c20ea4b35020fbdd = `Q7FggG_spectrum-Menu-sectionHeading`;
$286d1cb34bb7dc84$export$d7e47bfca92b5744 = `Q7FggG_spectrum-Menu-subdialog`;
$286d1cb34bb7dc84$export$76d36e55740ad742 = `Q7FggG_spectrum-Menu-wrapper`;
$286d1cb34bb7dc84$export$c873119be41fdb72 = `Q7FggG_spectrum-Menu-wrapper--isMobile`;
$286d1cb34bb7dc84$export$c830d2588e34dae1 = `Q7FggG_spectrum-Submenu-heading`;
$286d1cb34bb7dc84$export$d3fc690f61339a08 = `Q7FggG_spectrum-Submenu-headingWrapper`;
$286d1cb34bb7dc84$export$fe967dac6207a986 = `Q7FggG_spectrum-Submenu-popover`;
$286d1cb34bb7dc84$export$158cbd6607d36c4e = `Q7FggG_spectrum-Submenu-wrapper`;
$286d1cb34bb7dc84$export$6f093cfa640b7166 = `Q7FggG_text`;




function $86983ea1fa3f7312$export$feb3b6b552c14a12(props) {
    let { item: item, shouldSelectOnPressUp: shouldSelectOnPressUp, shouldFocusOnHover: shouldFocusOnHover, shouldUseVirtualFocus: shouldUseVirtualFocus } = props;
    let { rendered: rendered, key: key } = item;
    let ElementType = item.props.href ? "a" : "div";
    let state = (0, $j8tbs$useContext)((0, $0c6f792811e33483$export$7ff8f37d2d81a48d));
    let ref = (0, $j8tbs$useRef)();
    let { optionProps: optionProps, labelProps: labelProps, descriptionProps: descriptionProps, isSelected: isSelected, isDisabled: isDisabled, isFocused: isFocused } = (0, $j8tbs$useOption)({
        "aria-label": item["aria-label"],
        key: key,
        shouldSelectOnPressUp: shouldSelectOnPressUp,
        shouldFocusOnHover: shouldFocusOnHover,
        isVirtualized: true,
        shouldUseVirtualFocus: shouldUseVirtualFocus
    }, state, ref);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $j8tbs$useHover)({
        ...props,
        isDisabled: isDisabled
    });
    let contents = typeof rendered === "string" ? /*#__PURE__*/ (0, $j8tbs$react).createElement((0, $j8tbs$Text), null, rendered) : rendered;
    let isKeyboardModality = (0, $j8tbs$isFocusVisible)();
    return /*#__PURE__*/ (0, $j8tbs$react).createElement((0, $j8tbs$FocusRing), {
        focusRingClass: (0, $j8tbs$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "focus-ring")
    }, /*#__PURE__*/ (0, $j8tbs$react).createElement(ElementType, {
        ...(0, $j8tbs$mergeProps)(optionProps, shouldFocusOnHover ? {} : hoverProps),
        ref: ref,
        className: (0, $j8tbs$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Menu-item", {
            // If using virtual focus, apply focused styles to the item when the user is interacting with keyboard modality
            "is-focused": shouldUseVirtualFocus && isFocused && isKeyboardModality,
            "is-disabled": isDisabled,
            "is-selected": isSelected,
            "is-selectable": state.selectionManager.selectionMode !== "none",
            // When shouldFocusOnHover is false, apply hover styles both when hovered with the mouse.
            // Otherwise, apply hover styles when focused using non-keyboard modality.
            "is-hovered": isHovered && !shouldFocusOnHover || isFocused && !isKeyboardModality
        })
    }, /*#__PURE__*/ (0, $j8tbs$react).createElement((0, $j8tbs$Grid), {
        UNSAFE_className: (0, $j8tbs$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Menu-itemGrid")
    }, /*#__PURE__*/ (0, $j8tbs$react).createElement((0, $j8tbs$ClearSlots), null, /*#__PURE__*/ (0, $j8tbs$react).createElement((0, $j8tbs$SlotProvider), {
        slots: {
            text: {
                UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)))["spectrum-Menu-itemLabel"],
                ...labelProps
            },
            icon: {
                size: "S",
                UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)))["spectrum-Menu-icon"]
            },
            avatar: {
                size: "avatar-size-100",
                UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)))["spectrum-Menu-avatar"]
            },
            description: {
                UNSAFE_className: (0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports)))["spectrum-Menu-description"],
                ...descriptionProps
            }
        }
    }, contents, isSelected && /*#__PURE__*/ (0, $j8tbs$react).createElement((0, $j8tbs$spectrumiconsuiCheckmarkMedium), {
        slot: "checkmark",
        UNSAFE_className: (0, $j8tbs$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Menu-checkmark")
    }))))));
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 






function $92d678ed88836094$export$dca12b0bb56e4fc(props) {
    let { children: children, layoutInfo: layoutInfo, headerLayoutInfo: headerLayoutInfo, virtualizer: virtualizer, item: item } = props;
    let { headingProps: headingProps, groupProps: groupProps } = (0, $j8tbs$useListBoxSection)({
        heading: item.rendered,
        "aria-label": item["aria-label"]
    });
    let headerRef = (0, $j8tbs$useRef)();
    (0, $j8tbs$useVirtualizerItem)({
        layoutInfo: headerLayoutInfo,
        virtualizer: virtualizer,
        ref: headerRef
    });
    let { direction: direction } = (0, $j8tbs$useLocale)();
    let state = (0, $j8tbs$useContext)((0, $0c6f792811e33483$export$7ff8f37d2d81a48d));
    return /*#__PURE__*/ (0, $j8tbs$react).createElement((0, $j8tbs$Fragment), null, /*#__PURE__*/ (0, $j8tbs$react).createElement("div", {
        role: "presentation",
        ref: headerRef,
        style: (0, $j8tbs$layoutInfoToStyle)(headerLayoutInfo, direction)
    }, item.key !== state.collection.getFirstKey() && /*#__PURE__*/ (0, $j8tbs$react).createElement("div", {
        role: "presentation",
        className: (0, $j8tbs$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Menu-divider")
    }), item.rendered && /*#__PURE__*/ (0, $j8tbs$react).createElement("div", {
        ...headingProps,
        className: (0, $j8tbs$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Menu-sectionHeading")
    }, item.rendered)), /*#__PURE__*/ (0, $j8tbs$react).createElement("div", {
        ...groupProps,
        style: (0, $j8tbs$layoutInfoToStyle)(layoutInfo, direction),
        className: (0, $j8tbs$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Menu")
    }, children));
}










function $3247d4a89e6094e9$export$25768ea656ae32a7(state, isLoading) {
    let { scale: scale } = (0, $j8tbs$useProvider)();
    let collator = (0, $j8tbs$useCollator)({
        usage: "search",
        sensitivity: "base"
    });
    let layout = (0, $j8tbs$useMemo)(()=>new (0, $j8tbs$ListLayout)({
            estimatedRowHeight: scale === "large" ? 48 : 32,
            estimatedHeadingHeight: scale === "large" ? 33 : 26,
            padding: scale === "large" ? 5 : 4,
            loaderHeight: 40,
            placeholderHeight: scale === "large" ? 48 : 32,
            collator: collator
        }), [
        collator,
        scale
    ]);
    layout.collection = state.collection;
    layout.disabledKeys = state.disabledKeys;
    (0, $j8tbs$useLayoutEffect)(()=>{
        // Sync loading state into the layout.
        if (layout.isLoading !== isLoading) {
            var _layout_virtualizer;
            layout.isLoading = isLoading;
            (_layout_virtualizer = layout.virtualizer) === null || _layout_virtualizer === void 0 ? void 0 : _layout_virtualizer.relayoutNow();
        }
    }, [
        layout,
        isLoading
    ]);
    return layout;
}
/** @private */ function $3247d4a89e6094e9$var$ListBoxBase(props, ref) {
    let { layout: layout, state: state, shouldSelectOnPressUp: shouldSelectOnPressUp, focusOnPointerEnter: focusOnPointerEnter, shouldUseVirtualFocus: shouldUseVirtualFocus, domProps: domProps = {}, transitionDuration: transitionDuration = 0, onScroll: onScroll } = props;
    let { listBoxProps: listBoxProps } = (0, $j8tbs$useListBox)({
        ...props,
        keyboardDelegate: layout,
        isVirtualized: true
    }, state, ref);
    let { styleProps: styleProps } = (0, $j8tbs$useStyleProps)(props);
    let stringFormatter = (0, $j8tbs$useLocalizedStringFormatter)((0, (/*@__PURE__*/$parcel$interopDefault($0815878b47e2c7ae$exports))), "@react-spectrum/listbox");
    let renderWrapper = (parent, reusableView, children, renderChildren)=>{
        if (reusableView.viewType === "section") return /*#__PURE__*/ (0, $j8tbs$react).createElement((0, $92d678ed88836094$export$dca12b0bb56e4fc), {
            key: reusableView.key,
            item: reusableView.content,
            layoutInfo: reusableView.layoutInfo,
            virtualizer: reusableView.virtualizer,
            headerLayoutInfo: children.find((c)=>c.viewType === "header").layoutInfo
        }, renderChildren(children.filter((c)=>c.viewType === "item")));
        return /*#__PURE__*/ (0, $j8tbs$react).createElement((0, $j8tbs$VirtualizerItem), {
            key: reusableView.key,
            layoutInfo: reusableView.layoutInfo,
            virtualizer: reusableView.virtualizer,
            parent: parent === null || parent === void 0 ? void 0 : parent.layoutInfo
        }, reusableView.rendered);
    };
    return /*#__PURE__*/ (0, $j8tbs$react).createElement((0, $0c6f792811e33483$export$7ff8f37d2d81a48d).Provider, {
        value: state
    }, /*#__PURE__*/ (0, $j8tbs$react).createElement((0, $j8tbs$FocusScope), null, /*#__PURE__*/ (0, $j8tbs$react).createElement((0, $j8tbs$Virtualizer), {
        ...styleProps,
        ...(0, $j8tbs$mergeProps)(listBoxProps, domProps),
        ref: ref,
        focusedKey: state.selectionManager.focusedKey,
        autoFocus: !!props.autoFocus,
        sizeToFit: "height",
        scrollDirection: "vertical",
        className: (0, $j8tbs$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Menu", styleProps.className),
        layout: layout,
        collection: state.collection,
        renderWrapper: renderWrapper,
        transitionDuration: transitionDuration,
        isLoading: props.isLoading,
        onLoadMore: props.onLoadMore,
        shouldUseVirtualFocus: shouldUseVirtualFocus,
        onScroll: onScroll
    }, (type, item)=>{
        if (type === "item") return /*#__PURE__*/ (0, $j8tbs$react).createElement((0, $86983ea1fa3f7312$export$feb3b6b552c14a12), {
            item: item,
            shouldSelectOnPressUp: shouldSelectOnPressUp,
            shouldFocusOnHover: focusOnPointerEnter,
            shouldUseVirtualFocus: shouldUseVirtualFocus
        });
        else if (type === "loader") return(// aria-selected isn't needed here since this option is not selectable.
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        /*#__PURE__*/ (0, $j8tbs$react).createElement("div", {
            role: "option",
            style: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%"
            }
        }, /*#__PURE__*/ (0, $j8tbs$react).createElement((0, $j8tbs$ProgressCircle), {
            isIndeterminate: true,
            size: "S",
            "aria-label": state.collection.size > 0 ? stringFormatter.format("loadingMore") : stringFormatter.format("loading"),
            UNSAFE_className: (0, $j8tbs$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($286d1cb34bb7dc84$exports))), "spectrum-Dropdown-progressCircle")
        })));
        else if (type === "placeholder") {
            let emptyState = props.renderEmptyState ? props.renderEmptyState() : null;
            if (emptyState == null) return null;
            return /*#__PURE__*/ (0, $j8tbs$react).createElement("div", {
                // aria-selected isn't needed here since this option is not selectable.
                // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
                role: "option"
            }, emptyState);
        }
    })));
}
// forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref
const $3247d4a89e6094e9$export$1afdcf349979fb7e = /*#__PURE__*/ (0, $j8tbs$react).forwardRef($3247d4a89e6094e9$var$ListBoxBase);





function $3136257018b1a220$var$ListBox(props, ref) {
    let state = (0, $j8tbs$useListState)(props);
    let layout = (0, $3247d4a89e6094e9$export$25768ea656ae32a7)(state, props.isLoading);
    let domRef = (0, $j8tbs$useDOMRef)(ref);
    return /*#__PURE__*/ (0, $j8tbs$react).createElement((0, $3247d4a89e6094e9$export$1afdcf349979fb7e), {
        ...props,
        ref: domRef,
        state: state,
        layout: layout
    });
}
// forwardRef doesn't support generic parameters, so cast the result to the correct type
// https://stackoverflow.com/questions/58469229/react-with-typescript-generics-while-using-react-forwardref
/**
 * A list of options that can allow selection of one or more.
 */ const $3136257018b1a220$export$41f133550aa26f48 = /*#__PURE__*/ (0, $j8tbs$react).forwardRef($3136257018b1a220$var$ListBox);






export {$3136257018b1a220$export$41f133550aa26f48 as ListBox, $3247d4a89e6094e9$export$25768ea656ae32a7 as useListBoxLayout, $3247d4a89e6094e9$export$1afdcf349979fb7e as ListBoxBase, $ee97ea796309b076$re_export$Item as Item, $ee97ea796309b076$re_export$Section as Section};
//# sourceMappingURL=module.js.map
